export interface ChatState {
  status: 'idle' | 'loading' | 'complete' | 'failed';
}

export const initialState: ChatState = {
  status: 'idle',
};
